var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "health-dashboard-container" },
    [
      _c(
        "div",
        { staticClass: "dashboard-left" },
        [
          _c("DietRecord", {
            attrs: {
              "food-list": _vm.dietList,
              "fasting-list": _vm.fastingFoodList,
              "fasting-count": _vm.fastingFoodCount,
              "active-tab": _vm.dietType,
              "total-count": _vm.dietTotalCount,
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("diet", tab) },
          }),
          _c("ExerciseRecord", {
            attrs: {
              "exercise-list": _vm.exerciseList,
              "active-tab": _vm.sportType,
              stats: _vm.exerciseStats,
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("sport", tab) },
          }),
          _c("SleepRecord", {
            attrs: {
              "sleep-data": _vm.sleepRawData,
              "active-tab": _vm.sleepType,
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("sleep", tab) },
          }),
          _c("MassageRecord", {
            attrs: {
              "acupoint-list": _vm.massageList,
              "active-tab": _vm.massageType,
              "total-count": _vm.massageTotalCount,
            },
            on: { "tab-change": (tab) => _vm.handleTabChange("massage", tab) },
          }),
        ],
        1
      ),
      _c("div", { staticClass: "digital-human-section" }, [
        _c("div", { staticClass: "circle-background" }),
        _c("div", { staticClass: "digital-human-container" }, [
          _vm.sexsign != 1
            ? _c("img", {
                staticClass: "digital-human-img",
                attrs: {
                  src: require("@/assets/icon/numwuman.png"),
                  alt: "数字人",
                },
              })
            : _vm._e(),
          _vm.sexsign == 1
            ? _c("img", {
                staticClass: "digital-human-img",
                attrs: {
                  src: require("@/assets/icon/numman.png"),
                  alt: "数字人",
                },
              })
            : _vm._e(),
        ]),
        _c(
          "div",
          {
            staticClass: "chat-bubble",
            on: { click: _vm.viewConstitutionReport },
          },
          [
            _c("div", { staticClass: "bubble-arrow" }),
            _c("p", { staticClass: "bubble-text" }, [
              _vm._v(
                "我是" + _vm._s(_vm.tizhi.name) + "，请点击查看我的体质报告"
              ),
            ]),
          ]
        ),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "体质报告",
            visible: _vm.dialogVisible,
            width: "600px",
            "close-on-click-modal": true,
            "custom-class": "constitution-dialog",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
          },
        },
        [
          _c("div", {
            staticClass: "constitution-content",
            domProps: { innerHTML: _vm._s(_vm.constitutionContent) },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "积分明细",
            visible: _vm.pointsDialogVisible,
            width: "600px",
            "close-on-click-modal": true,
            "custom-class": "points-dialog",
            "append-to-body": "",
          },
          on: {
            "update:visible": function ($event) {
              _vm.pointsDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "points-table-container" },
            [
              _c(
                "el-table",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: !_vm.countIntegralList.length,
                      expression: "!countIntegralList.length",
                    },
                  ],
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.countIntegralList,
                    stripe: "",
                    height: "400px",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      prop: "pointsLogDesc",
                      label: "事件",
                      "min-width": "200",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "integralChange",
                      label: "积分变动",
                      width: "120",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _c(
                              "span",
                              {
                                class:
                                  scope.row.integralChange >= 0
                                    ? "points-plus"
                                    : "points-minus",
                              },
                              [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      scope.row.integralChange >= 0 ? "+" : ""
                                    ) +
                                    _vm._s(scope.row.integralChange) +
                                    " "
                                ),
                              ]
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                  _c("el-table-column", {
                    attrs: {
                      prop: "createTime",
                      label: "时间",
                      width: "160",
                      align: "center",
                    },
                    scopedSlots: _vm._u([
                      {
                        key: "default",
                        fn: function (scope) {
                          return [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.createTime
                                    ? new Date(
                                        scope.row.createTime
                                      ).toLocaleString("zh-CN")
                                    : ""
                                ) +
                                " "
                            ),
                          ]
                        },
                      },
                    ]),
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  layout: "prev, pager, next, total",
                  "current-page": _vm.currentPage,
                  "page-size": _vm.pageSize,
                  total: _vm.totalCount,
                },
                on: {
                  "update:currentPage": function ($event) {
                    _vm.currentPage = $event
                  },
                  "update:current-page": function ($event) {
                    _vm.currentPage = $event
                  },
                  "current-change": _vm.handlePointsPageChange,
                },
              }),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.pointsDialogVisible = false
                    },
                  },
                },
                [_vm._v("关 闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }